import modeEdit from '../../../assets/icons/mode_edit.svg'

interface ModeEditBtnProps {
    onClick: () => void
    className?: string
}

export const ModeEditBtn = (props: ModeEditBtnProps) => {
    const { onClick, className } = props

    return (
        <button
            onClick={onClick}
            className={`green-rounded-btn ${className}`}
        >
            <img
                src={modeEdit}
                alt="mode edit"
            />
        </button>
    )
}